import apiService from './apiService';

export default {
  importProduct(payload) {
    return apiService.post('/api/products/agent/import', payload);
  },
  confirmCategory(payload) {
    return apiService.post('/api/products/agent/import/confirm-category', payload);
  }
};
